module.exports = __webpack_public_path__ + "static/media/MITTFLIX.fa2cb3bd.png";